import apiClient from 'ps-components/lib/apiClient';

export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_FETCH_INIT = 'SESSION_FETCH_INIT';
export const SESSION_FETCH_SUCCESS = 'SESSION_FETCH_SUCCESS';
export const SESSION_FETCH_FAIL = 'SESSION_FETCH_FAIL';
export const SESSION_DATA_FETCH_SUCCESS = 'SESSION_DATA_FETCH_SUCCESS';
export const GET_JDX_SESSION_KEY = 'GET_JDX_SESSION_KEY';
export const GET_JDX_SESSION_KEY_FAIL = 'GET_JDX_SESSION_KEY_FAIL';
export const GET_JDX_SESSION_KEY_SUCCESS = 'GET_JDX_SESSION_KEY_SUCCESS';
export const REFRESH_JDX_SESSION_KEY = 'REFRESH_JDX_SESSION_KEY';
export const FEATUREFLAG_FETCH_INIT = 'FEATUREFLAG_FETCH_INIT';
export const FEATUREFLAG_FETCH_SUCCESS = 'FEATUREFLAG_FETCH_SUCCESS';
export const FEATUREFLAG_FETCH_FAIL = 'FEATUREFLAG_FETCH_FAIL';
export const RESET_ERROR = 'RESET_ERROR';
export const SET_ERROR = 'SET_ERROR';
export const GROUPS_FETCH_SUCCESS = 'GROUPS_FETCH_SUCCESS';
export const ORGANIZATIONS_FETCH_SUCCESS = 'ORGANIZATIONS_FETCH_SUCCESS';
export const ORGANIZATION_FETCH_SUCCESS = 'ORGANIZATION_FETCH_SUCCESS';

export function logout() {
  console.log('logout');
  return {
    type: SESSION_LOGOUT
  };
}

export const getSession = (isRefresh = false) => async dispatch => {
  dispatch({ type: SESSION_FETCH_INIT });

  try {
    // Also retrieve the sessionData to get SalesforceID
    const response = await apiClient.apiPost('/api/util/session-data/sessionData', {
      isRefresh
    });
    const sessionData = response?.data?.app;
    if (!sessionData) {
      throw Error('Error getting session data');
    }

    dispatch({
      type: SESSION_DATA_FETCH_SUCCESS,
      data: sessionData
    });
    dispatch({
      type: GROUPS_FETCH_SUCCESS,
      data: sessionData?.groups
    });
    dispatch({
      type: ORGANIZATIONS_FETCH_SUCCESS,
      data: sessionData?.organizations
    });
    dispatch({
      type: ORGANIZATION_FETCH_SUCCESS,
      data: sessionData?.organization
    });
    dispatch({
      type: FEATUREFLAG_FETCH_SUCCESS,
      data: sessionData?.featureFlags
    });

    dispatch({
      type: SESSION_FETCH_SUCCESS
    });
  } catch (error) {
    console.error('getSession error: ', error);
    dispatch({ type: SESSION_FETCH_FAIL });

    const status = error?.response?.status;

    if (status === 401 || status === 403) return dispatch(logout());
    if (status === 404 || status === 400) return;
  }
};

export const validateSession = () => async dispatch => {
  try {
    await apiClient.apiPost('/services', {
      query: `
        query heartbeat {
          heartbeat: version
        }
      `
    });
  } catch (error) {
    console.log('Validate Session error:', error && error.response);
    const status = error && error.response && error.response.status;

    if (status === 401 || status === 403) return dispatch(logout());
    if (status === 404 || status === 400) return;
    return dispatch(setError(status));
  }
};

export const setError = errorCode => async dispatch => {
  dispatch({
    type: SET_ERROR,
    data: errorCode
  });
};

export const resetError = () => async dispatch => {
  dispatch({
    type: RESET_ERROR
  });
};

export function getJdxSession(masterAccountId) {
  return async dispatch => {
    dispatch({
      type: GET_JDX_SESSION_KEY
    });
    const sessionData = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/jdxSessionKey`);
    if (sessionData.data.status === 200) {
      dispatch({
        type: GET_JDX_SESSION_KEY_SUCCESS,
        jdxSessionKey: sessionData.data.data.sessionKey
      });
    }
  };
}

export function refreshJdxTimeout() {
  return { type: REFRESH_JDX_SESSION_KEY };
}
